import React from 'react';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { List, Map } from 'immutable';
export var InvitationFormComponent = function InvitationFormComponent(props) {
  var InviteesInput = props.renderInviteesInput;
  return props.render({
    formElement: /*#__PURE__*/React.createElement("form", {
      className: "invitation-form",
      onSubmit: props.handleSubmit
    }, /*#__PURE__*/React.createElement("div", {
      className: "form-group required"
    }, /*#__PURE__*/React.createElement("label", null, "Invitees"), /*#__PURE__*/React.createElement(InviteesInput, {
      id: "invitees",
      onChange: props.handleUserChange,
      value: props.values.get('invitees'),
      disabledFn: props.disabledFn
    }), /*#__PURE__*/React.createElement("small", {
      className: "form-text text-muted"
    }, "Enter a valid email address to invite a new user")), /*#__PURE__*/React.createElement("div", {
      className: "form-group"
    }, /*#__PURE__*/React.createElement("label", {
      htmlFor: "message"
    }, "Message for Invitees"), /*#__PURE__*/React.createElement("textarea", {
      name: "message",
      id: "message",
      onChange: props.handleChange,
      value: props.values.get('message')
    }), /*#__PURE__*/React.createElement("small", {
      className: "form-text text-muted"
    }, "This note will be sent as part of the invitation and visible to all members inside the discussion"))),
    invalid: props.required && props.values.get('invitees').size === 0,
    submit: props.handleSubmit,
    buttonProps: {
      onClick: props.handleSubmit,
      disabled: props.saving || props.required && props.values.get('invitees').size === 0
    }
  });
};

var mapProps = function mapProps(props) {
  return {
    associatedUsers: props.discussion ? props.discussion.participants.concat(props.discussion.invitations.filter(function (invitation) {
      return invitation.user;
    })).map(function (involvement) {
      return involvement.user.username;
    }) : List([props.profile.username]),
    associatedEmails: props.discussion ? props.discussion.invitations.filter(function (invitation) {
      return invitation.email;
    }).map(function (invitation) {
      return invitation.email;
    }) : List()
  };
};

var handleChange = function handleChange(props) {
  return function (event) {
    var field = event.target.id;
    var value = event.target.value;
    props.setValues(function (values) {
      return values.set(field, value);
    });
  };
};

var handleUserChange = function handleUserChange(props) {
  return function (user) {
    props.setValues(function (values) {
      return values.set('invitees', user ? user : List());
    });
  };
};

var handleSubmit = function handleSubmit(props) {
  return function (event) {
    event && event.preventDefault && event.preventDefault();
    props.setSaving(true);

    if (typeof props.onSubmit === 'function') {
      props.onSubmit(props.values, function () {
        return props.setSaving(false);
      });
    }
  };
};

var disabledFn = function disabledFn(props) {
  return function (option) {
    if (option.user) {
      return props.associatedUsers.contains(option.user.username) && 'Already involved';
    } else if (option.customOption) {
      return props.associatedEmails.contains(option.label) && 'Already invited';
    }

    return false;
  };
};

export var InvitationForm = compose(withProps(mapProps), withState('saving', 'setSaving', false), withState('values', 'setValues', Map({
  invitees: List(),
  message: ''
})), withHandlers({
  handleChange: handleChange,
  handleUserChange: handleUserChange,
  handleSubmit: handleSubmit,
  disabledFn: disabledFn
}))(InvitationFormComponent);
export default InvitationForm;